import { Component, Input } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppState, RoleMgr } from '../../../core';
import { ScoutPointLocalPhoto, ScoutPointLocalPhotoUrl, ScoutPointPhoto, TaskStatus } from '../../../core/models';
import { ScoutPointPhotoDoc } from '../../../core/schema/scout-point-photo-schema';
import { ScoutPointLocalPhotoService, ScoutPointLocalPhotoUrlService, ScoutPointPhotoService, ScoutPointPhotoUploadService, ScoutTaskService } from '../../../core/services';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ScoutPointPhotoSelected } from '../scout-point-photo-browser/scout-point-photo-browser.component';
import { ScoutPointPhotoModal } from '../scout-point-photo-modal/scout-point-photo-modal.component';

@Component({
  selector: 'app-scout-photos-status-panel',
  templateUrl: './scout-photos-status-panel.component.html',
  styleUrls: ['./scout-photos-status-panel.component.scss']
})
export class ScoutPhotosStatusPanelComponent {

  @Input() errorPhotoCnt = 0
  @Input() pendingPhotoCnt = 0
  @Input() uploadingPhotoCnt = 0

  selectedPhotos : { 
    [param: string]: { 
        localPhoto : ScoutPointLocalPhoto, 
        localPhotoUrl$ : Observable<ScoutPointLocalPhotoUrl>, 
        localPhotoUrlErr : string,
        photoDoc$ : Observable<ScoutPointPhotoDoc>,
        photoDocErr: string
      }
  } = {}

  readonly nullUrl = new ScoutPointLocalPhotoUrl()
  readonly nullPhoto = new ScoutPointPhoto()
  
  constructor(
      public appState : AppState,
      public photoService: ScoutPointPhotoService,
      public localPhotoService: ScoutPointLocalPhotoService,
      public localPhotoUrlService: ScoutPointLocalPhotoUrlService,
      public scoutPhotoUploadService: ScoutPointPhotoUploadService,
      public scoutTaskService: ScoutTaskService,
      public bsModalService: BsModalService,
      public roleMgr: RoleMgr )  {
  }


  async retryUpload( photoFileDoc: ScoutPointLocalPhoto ) {
    return await this.localPhotoService.flagForUpload(photoFileDoc)
  }

  toggleDetailsPanel( localPhoto: ScoutPointLocalPhoto ) {
    const selectedPhotoInfo = this.selectedPhotos[localPhoto._id]
    if ( selectedPhotoInfo ) {
      delete this.selectedPhotos[localPhoto._id]
    } else {
      let docMeta : any = { 
        localPhoto
      }
      const localDocPromise = this.localPhotoUrlService.getById(localPhoto._id)
      docMeta.localPhotoUrl$ = from(localDocPromise).pipe( 
        map(d=>d?d:this.nullUrl),
        catchError(e=>{ 
          docMeta.localPhotoUrlErr = this.localPhotoService.extractErrorMsg(e); 
          return of(null)
        })
      )
      const photoDocPromise = this.photoService.rxCollection.findOne(localPhoto._id).exec()
      docMeta.photoDoc$ = from(photoDocPromise).pipe( 
        map(d=>d?d:this.nullPhoto),
        catchError(e=>{
          docMeta.photoDocErr = this.localPhotoService.extractErrorMsg(e); 
          return of(null)            
        })
      )   
      this.selectedPhotos[localPhoto._id] = docMeta         
    }
  }


  async showPhoto( photoDoc : ScoutPointPhotoDoc ) {
    // find task and path
    const [ taskId, pathId, pointId ] = photoDoc._id.split('/')
    console.log( `taskId: ${taskId}` )
    console.log( `pathId: ${pathId}` )
    console.log( `pointId: ${pointId}` )
    const scoutTask = await this.scoutTaskService.rxCollection.findOne(taskId).exec()
    let { scoutPath, scoutPoint } = this.scoutTaskService.getPathAndPoint(scoutTask,pathId,pointId)
    if ( !scoutPath ) {
      this.photoService.publishError('Could not find scout path for photo doc',this)
    } else if ( scoutPoint?.id != photoDoc.scoutPointId ) {
      // photo may have been moved to another point so cannot relay on values extracted from photo id
      scoutPoint = scoutPath.scoutPoints.find(sp=>sp.id==photoDoc.scoutPointId)
    }
    if ( scoutPath && scoutPoint) {
      this.showScoutPointPhoto( {
          group: null,
          task : scoutTask,
          path : scoutPath,
          point : scoutPoint,
          photos: [],
          photoGroup: null,
          photo: photoDoc
      })
    }
  }


  async deleteLocalPhoto( localPhoto : ScoutPointLocalPhoto ) {
    let initialState = {
      onYes: async () => {
          try {
            await this.localPhotoService.removeLocalPhotoFile(localPhoto._id)
          } catch ( error : any ) {
            this.localPhotoService.publishError(error,this)
          }
      },
      question: `This option addresses when a local photo is corrupt and has failed to upload multiple times.
      Are you sure you wish to permanently delete the local photo?`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.bsModalService.show(ConfirmModalComponent, { initialState });  
  }

  showScoutPointPhoto = ( photoSelectedEvt : ScoutPointPhotoSelected ) => {
    //console.log( JSON.stringify(photoSelectedEvt.photo.toJSON()))
    let uiLocked = TaskStatus.uiLockHandler(photoSelectedEvt.path?.statusId, this.roleMgr.canEditUsers)      
    const context : ModalOptions = {
      initialState: {
        locked: uiLocked,
        ...photoSelectedEvt
      },
      class: 'photo-modal',
      id: ScoutPointPhotoModal.ModalId,
      animated: true,
      ignoreBackdropClick: true    
    } 
    const modalRef = this.bsModalService.show(ScoutPointPhotoModal, context );
}
}
